<template>
    <div>
        <draggable class="list" v-model="setTingObj.listConfig.list" :animation="150">
            <div class="item" v-for='(item,index) in setTingObj.listConfig.list' :key="index">
                <div class='delete-btn' @click='deleteItem(index)'>
                    <i class='el-icon-error'></i>
                </div>
                <div class='flag'>
                    <i class='el-icon-more'></i>
                </div>
                <div class="item-right">
                    <div class="inputText">
                        <span>{{ item.child[0].title }}</span>
                        <el-input size="small" v-model="item.child[0].val" :placeholder="item.child[0].pla" :maxlength="item.child[0].max"></el-input>
                    </div>
                    <div class="inputText">
                        <span>{{ item.child[1].title }}</span>
<!--                        <el-input size="small" v-model="item.child[1].val" :placeholder="item.child[1].pla" :maxlength="item.child[1].max"></el-input>-->
                        <pathselect :value="item.child[1].val" :disabled="false"  @change="changePathSelect($event,item.child[1])"></pathselect>
                    </div>
                </div>
            </div>
        </draggable>
        <div class='add-btn' @click="addItem">
            <span>添加</span>
        </div>
    </div>
</template>

<script>
import draggable from 'vuedraggable';
import uploadImage from '@/components/decoration/common/uploadImage.vue';
import Pathselect from '@/components/pathselect/pathselect.vue';
export default {
    components:{
        draggable,
        Pathselect,
    },
    props:{
        setTingObj:{
            type:Object,
            default:{}
        }
    },
    data() {
        return {};
    },
    methods: {
        deleteItem(index){
            this.setTingObj.listConfig.list.splice(index,1)
        },
        addItem(){
            if(this.setTingObj.listConfig.max > this.setTingObj.listConfig.list.length){
                this.setTingObj.listConfig.list.push({
                    child: [
                        {
                            title: "标题",
                            val: "",
                            max: 30,
                            pla: "选填，不超过30个字",
                            empty: true
                        },
                        {
                            title: "链接",
                            val: "",
                            max: 200,
                            pla: "请输入连接"
                        }
                    ]
                })
            }
        },
        changePathSelect(e,obj){
            obj.val = e;
        }
    }
};
</script>

<style lang='scss' scoped>
.item{
    position: relative;
    width: 100%;
    height: 100px;
    margin-top: 30px;
    padding-top: 10px;
    box-shadow: 0 0 10px #eee;
    display: flex;
    flex-direction: row;
    .delete-btn{
        position: absolute;
        font-size: 24px;
        right: 0;
        top: -15px;
    }
    .flag{
        width: 30px;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        >i{
            transform: rotate(90deg);
            color: #dddddd;
            cursor: move;
        }
    }

    .item-right{
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        .inputText{
            display: flex;
            align-items: center;
            span{
                width: 60px;
            }
            el-input{
                flex: 1;
            }
        }
    }
}

.add-btn{
    width: 100%;
    height: 40px;
    margin-top: 20px;
    background-color: #409EFF;
    border-radius: 3px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
}
</style>